<template>
  <div ref="baseModalRef" class="search-videos-container">

    <div class="modal-header">
      <h5>Alerce Search Module</h5>
    </div>

    <div class="modal-body" v-show="!isMinimized">

      <div id="buscador" class="form">
        <div class="container-fluid">
          <div class="row">
            <div class="media-container">
              <video-player ref="videoPlayerRef" v-if="reRenderPlayer" class="video-player vjs-theme-forest"
                :options="videoOptions" @timeChange="timeChange" />
            </div>


          </div>
          <div class="row">
            <div class="datos-media" :key="currentVideoDetail?.utc">
              <strong>Video Info</strong>
              <!-- Vista previa principal -->
              <div class="preview-row d-flex align-items-center" style="cursor:pointer;"
                @click="showDetails = !showDetails">
                <div style="flex:1">
                  <span>File: {{ video.fileName.split('\\').pop() }}</span>
                  <span style="margin-left:10px;">- UTC: {{ formatUtc(currentVideoDetail?.utc) }}</span>
                </div>
                <button class="btn btn-link btn-sm" @click.stop="showDetails = !showDetails"
                  :aria-expanded="showDetails">
                  <span v-if="showDetails">&#9650;</span><!-- ▲ -->
                  <span v-else>&#9660;</span><!-- ▼ -->
                </button>
              </div>

              <!-- Detalles expandibles -->
              <transition name="fade">
                <div v-if="showDetails">
                  <div class="row">
                    <div class="col-3"><span>Type</span></div>
                    <div class="col-9"><span>{{ currentVideoDetail?.name }}</span></div>
                  </div>
                  <div class="row">
                    <div class="col-3"><span>Aircraft</span></div>
                    <div class="col-9">
                      <span>
                        {{ currentVideoDetail?.sensor_lat }} {{ currentVideoDetail?.sensor_lon }} Rumbo
                        {{ currentVideoDetail?.platform_heading }}°
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-3"><span>FOV</span></div>
                    <div class="col-9">
                      <span>
                        H: {{ currentVideoDetail?.sensor_hfov }}° V:{{ currentVideoDetail?.sensor_vfov }}°
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-3"><span>Slant Range</span></div>
                    <div class="col-9"><span>{{ currentVideoDetail?.slant_range }} M</span></div>
                  </div>
                  <div class="row">
                    <div class="col-3"><span>Image Center</span></div>
                    <div class="col-9">
                      <span>
                        {{ currentVideoDetail?.center_lat }} {{ currentVideoDetail?.center_lon }}
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-3"><span>Target Size</span></div>
                    <div class="col-9"><span>{{ currentVideoDetail?.targetwidth }} M</span></div>
                  </div>
                </div>
              </transition>
            </div>
            <div class="row mb-2"><button class="btn btn-secondary btn-sm btn-vlc-selected" @click="abrirEnVLC">Open in
                Player</button></div>
          </div>

          <div class="row mt-2 mb-2">
            <div class="col-6 col-6-small">

              <h5>Filters</h5>
              <div class="row">
                <div class="">
                  <select class="form-select form-select-sm mb-1" v-model="filters.data" aria-label="Video Type"
                    @change="callApi">
                    <option selected value="">Video</option>
                    <option value="PRIMARY">Primary</option>
                    <option value="ALTERNATE">Alternate</option>
                  </select>

                  <div class="filter-group">
                    <!-- FECHA DESDE -->
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" value="" id="showStartDate"
                        v-model="filters.showStartDate" @change="callApi" />
                      <label class="form-check-label" for="flexCheckDefault"> From </label>
                    </div>
                    <div v-if="filters.showStartDate">
                      <input type="date" v-model="filters.start_date" @change="callApi" class="form-control" />
                    </div>
                  </div>

                  <div class="filter-group">
                    <!-- FECHA HASTA -->
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" value="" id="showEndDate"
                        v-model="filters.showEndDate" @change="callApi" />
                      <label class="form-check-label" for="flexCheckDefault"> To </label>
                    </div>
                    <div v-if="filters.showEndDate">
                      <input type="date" v-model="filters.end_date" @change="callApi" class="form-control" />
                    </div>
                  </div>

                  <div class="filter-group">
                    <!-- TIPO -->
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" value="" id="type" v-model="filters.showTipo"
                        @change="callApi" />
                      <label class="form-check-label" for="flexCheckDefault"> Type </label>
                    </div>
                    <div :hidden="!filters.showTipo">
                      <select v-model="filters.tipo" @change="callApi" class="form-control">
                        <option class="form-select form-select-sm" value="HD-EO">HD-EO</option>
                        <option class="form-select form-select-sm" value="MWIR">MWIR</option>
                      </select>
                    </div>
                  </div>

                  <div class="filter-group">
                    <!-- ZONA -->
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" value="" id="showZona" v-model="filters.showZona"
                        @change="callApi" />
                      <label class="form-check-label" for="flexCheckDefault"> Zone </label>
                    </div>
                    <div :hidden="!filters.showZona" class="form-text">
                      <label class="form-text-label" for="flexTextDefault"> Lat </label>
                      <input class="form-number-input" type="number" id="init_number" v-model="filters.lat_zona"
                        @change="callApi" />
                      <label class="form-text-label" for="flexTextDefault"> Lon </label>
                      <input class="form-number-input" type="number" id="end_number" v-model="filters.lon_zona"
                        @change="callApi" />

                      <label class="form-text-label" for="rad_zona"> Radius </label>
                      <input class="form-number-input" type="number" id="rad_zona" v-model="filters.rad_zona"
                        @change="callApi" />
                    </div>
                  </div>

                  <div class="filter-group">
                    <!-- PREDIO -->
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" value="" id="showPredios"
                        v-model="filters.showPredio" @change="callApi" />
                      <label class="form-check-label" for="flexCheckDefault"> Predio </label>
                    </div>
                    <div :hidden="!filters.showPredio" v-if="prediosList">
                      <select class="form-select form-select-sm" aria-label="Default select example"
                        v-model="filters.predio_name" @change="callApi">
                        <option v-for="predio in prediosList" v-bind:key="predio.name">
                          {{ predio.name }}
                        </option>
                      </select>
                      <label class="form-text-label" for="flexTextDefault"> Radius </label>
                      <input class="form-number-input" type="number" v-model="filters.predio_rad" @change="callApi" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-5 col-5-small">
              <div class="text-center">
                <span>Filtered Videos <span>({{ cantidadVideos }})</span></span>
              </div>
              <div class="video-list">
                <div v-for="video in videoFiles" :key="video.id_file"
                  @click="changeVideo(video.file_name, video.id_file)" class="video-list-item"
                  :class="{ selected: currentVideoId === video.id_file }">
                  {{ video.file_name.split('\\')[1] }}
                </div>
              </div>
            </div>


          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, reactive, watch, onMounted, watchEffect, onBeforeUnmount } from 'vue'
import VideoPlayer from './VideoPlayer.vue'
import 'video.js/dist/video-js.css'
import { useBrowserDetect } from 'vue3-detect-browser'
import type { VideoFile, VideoFilesFilter } from '../types'
import API from '../services'
import { AxiosError } from 'axios'
import { useGlobalStore } from '@/stores/global'
import { useServicesStore } from '@/stores/services'
import { storeToRefs } from 'pinia'

const props = defineProps({
  modalId: { type: String, required: true },
  title: { type: String, default: 'Modal' },
  isVisible: { type: Boolean, required: true }
})

const emit = defineEmits(['close', 'minimize', 'restore', 'videoSelected'])
const globalStore = useGlobalStore()
const modal = ref<HTMLElement | null>(null)
const isMinimized = ref(false)
const showDetails = ref(false)

// Expone el estado minimizado para que el sidebar pueda accederlo
defineExpose({
  isMinimized,
  restoreModal
})

function restoreModal() {
  console.log('Restaurando modal:', props.modalId)
  isMinimized.value = false
  emit('restore', props.modalId)
}

// Corrige la posición si la barra superior queda fuera de la pantalla
function ensureModalInViewport() {
  if (!modal.value) return
  const rect = modal.value.getBoundingClientRect()
  let left = rect.left
  let top = rect.top
  let changed = false

  // Limita para que la barra superior no salga por arriba ni por la izquierda
  if (left < 0) {
    left = 0
    changed = true
  }
  if (top < 0) {
    top = 0
    changed = true
  }
  // Opcional: también puedes limitar derecha/abajo si quieres
  const maxLeft = window.innerWidth - rect.width
  const maxTop = window.innerHeight - 40 // 40px: altura aprox. del header
  if (left > maxLeft) {
    left = maxLeft
    changed = true
  }
  if (top > maxTop) {
    top = maxTop
    changed = true
  }

  if (changed) {
    modal.value.style.left = `${left}px`
    modal.value.style.top = `${top}px`
    globalStore.setModalState(props.modalId, {
      left: `${left}px`,
      top: `${top}px`,
      width: rect.width + 'px',
      height: rect.height + 'px'
    })
  }
}

onBeforeUnmount(() => {
  // Guarda el estado actual antes de desmontar
  if (modal.value) {
    const rect = modal.value.getBoundingClientRect()
    globalStore.setModalState(props.modalId, {
      left: `${rect.left}px`,
      top: `${rect.top}px`,
      width: `${rect.width}px`,
      height: `${rect.height}px`
    })
  }
  window.removeEventListener('resize', ensureModalInViewport)
})

// Corrige si cambia el estado del modal (por ejemplo, al abrir/cerrar)
watchEffect(() => {
  if (props.isVisible) {
    setTimeout(ensureModalInViewport, 0)
  }
})

const global = useGlobalStore()
const { currentVideoId, currentVideoDetail, videoDetails, selectedVideoMarker } =
  storeToRefs(global)

const serv = useServicesStore()
const { prediosList } = storeToRefs(serv)

const { isSafari } = useBrowserDetect()

const videoFiles = ref<VideoFile[]>([])
const cantidadVideos = ref(0)
const videoPlayerRef = ref()
const currentVideoName = ref('')



const filters = reactive({
  showStartDate: false,
  showEndDate: false,
  start_date: '',
  end_date: '',
  data: '',
  showTipo: false,
  tipo: '',
  inicio_objetivo: 0,
  final_objetivo: 0,
  showZona: false,
  lat_zona: 0,
  lon_zona: 0,
  rad_zona: 10,
  showPredio: false,
  predio_name: '',
  predio_rad: 10
})
const video = reactive({
  fileName: ''
})



function playFromFrametime(frametimeMs: number) {
  // Espera un poco si es necesario para que el video esté listo
  setTimeout(() => {
    videoPlayerRef.value?.seekTo(frametimeMs)
  }, 300)
}

function closeDialog() {
  emit('close')
}

const videoOptions = reactive({
  autoplay: true,
  controls: true,
  fluid: false,
  preload: 'auto',
  html5: {
    vhs: {
      overrideNative: !isSafari,
      bandwidth: 5039
    },
    nativeAudioTracks: false,
    nativeVideoTracks: false
  },
  sources: [
    {
      src: '/videos/2024-02-28_19-21-13/2024-02-28_19-21-13_PRIMARY.m3u8',
      type: 'application/x-mpegURL'
    }
  ],
  width: 500,
  height: 300
})


function formatUtc(str?: string): string {
  if (!str) return ''
  // Espera formato: "2024-02-28_18-41-37-003"
  const match = str.match(/^(\d{4}-\d{2}-\d{2})_(\d{2})-(\d{2})-(\d{2})-(\d{3})$/)
  if (!match) return str
  const [, date, hh, mm, ss, ms] = match
  return `${date} ${hh}:${mm}:${ss}.${ms}`
}
onMounted(() => {
  callApi()
})
const reRenderPlayer = ref(false)

function changeVideo(file_name: string, id_file: number) {
  currentVideoId.value = id_file
  video.fileName = file_name
  currentVideoName.value = file_name
  reRenderPlayer.value = false
  videoOptions.sources[0].src = '/fserver/videos/' + file_name + '.m3u8'
  listVideoDetails(id_file)

  setTimeout(() => {
    reRenderPlayer.value = true

    if (selectedVideoMarker.value !== undefined && selectedVideoMarker.value !== null) {
      playFromFrametime(selectedVideoMarker.value)
    }
    selectedVideoMarker.value = null
  }, 100)
}
async function listVideoDetails(id_file: number) {
  try {
    const { status, data } = await API.listVideoDetails(id_file)

    if (status == 200) {
      
      const entries = data.Entries?.Entry
      videoDetails.value = Array.isArray(entries) ? entries :  [] 
      currentVideoDetail.value = videoDetails.value[0]
      console.log('Emitiendo videoSelected con coords:', currentVideoDetail.value?.center_lon, currentVideoDetail.value?.center_lat)
      emit('videoSelected', [
        Number.parseFloat(currentVideoDetail.value?.center_lon || '0'),
        Number.parseFloat(currentVideoDetail.value?.center_lat || '0')
      ])
    } else {
      console.log('error')
    }
  } catch (error) {
    const _error = error as AxiosError<string>
    console.error(_error.message)
  }
}
function timeChange(currentTime: number) {
  if (!videoDetails.value || videoDetails.value.length === 0) {
    return
  }
  
  const closestDetail = videoDetails.value.reduce((prev, curr) => {
    return Math.abs(Number.parseFloat(curr.frametime) - currentTime) <
      Math.abs(Number.parseFloat(prev.frametime) - currentTime)
      ? curr
      : prev
  })

  currentVideoDetail.value = { ...closestDetail }
}
async function abrirEnVLC() {
  const url = 'https://apialerce.terminus.cl/fserver/videos/' + currentVideoName.value.replace('\\', '/') + '.ts';
  console.log('Llamando a Player con URL: ' + url);
  const start_time = currentVideoDetail.value && currentVideoDetail.value.frametime
    ? Number.parseFloat(currentVideoDetail.value.frametime)
    : 0;
  const payload = {
    url,
    fullscreen: false,
    volume: 100,
    start_time: start_time
  };
  try {
    const response = await fetch('http://localhost:8001/play', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    if (response.status === 200) {
      window.close();
    }
  } catch (error) {
    console.error('Error al comunicar con Player:', error);
    alert('No se pudo comunicar con la API local TM-100 Player');
  }
}
async function callApi() {
  const filtros: VideoFilesFilter = {
    start_date: filters.showStartDate ? filters.start_date.replace(/-/g, '') : '',
    end_date: filters.showEndDate ? filters.end_date.replace(/-/g, '') : '',
    data: filters.data,
    tipo: filters.showTipo ? filters.tipo : '',
    inicio_objetivo: 0,
    final_objetivo: 0,
    lat_zona: filters.showZona ? filters.lat_zona : 0,
    lon_zona: filters.showZona ? filters.lon_zona : 0,
    rad_zona: filters.showZona ? filters.rad_zona : 0,
    predio_name: filters.showPredio ? filters.predio_name : '',
    predio_rad: filters.showPredio ? filters.predio_rad : 0
  }
  try {
    const { status, data } = await API.getVideos(filtros)

    if (status == 200) {
      videoFiles.value = data.Entries?.Entry || []
      cantidadVideos.value = videoFiles.value.length
    } else {
      videoFiles.value = []
      cantidadVideos.value = 0
    }
  } catch (error) {
    const _error = error as AxiosError<string>
    console.error(_error.message)
    videoFiles.value = []
    cantidadVideos.value = 0
  }
}
watch(selectedVideoMarker, () => {
  if (currentVideoId.value !== null && currentVideoId.value !== undefined) {
    changeVideo(video.fileName, currentVideoId.value)
  }
})



</script>
<style lang="css" scoped>
.search-videos-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  color: white;
}

/* clase global para los close de los modales */
.form {
  background-color: transparent;
}

span.closeCampos.close {
  height: 25px;
  line-height: 9px;
  background-color: #6c757d;
  padding: 6px;
  border-radius: 5px;
}

/* alto de tabla contenedor */

.table-wrapper {
  overflow-y: scroll;
  height: 80vh;
}

.my-3 {
  min-height: 1px;
}

.video-list-item {
  padding: 6px 12px;
  cursor: pointer;
  font-size: 13px;
}

.video-list-item.selected {
  background: #ffe082;
  color: black;
  font-weight: bold;
}

.video-list-item:hover {
  background: #f5f5f5;
}


.btn-vlc-selected {
  font-size: 11px !important;
  margin-right: 12px;
  width: 80%;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  max-height: 0;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
  max-height: 500px;
}

.modal-body {
  padding: 10px;
  overflow-y: scroll;
  height: calc(100vh - 75px);
}

.row .datos-media {
  max-width: none;
  margin-top: auto;
  overflow: hidden;
  text-wrap: wrap;
  margin-bottom: 10px;
}

.search-videos-container .modal-header {
  height: auto;
}

.btn-link {
  color: white;
  text-decoration: none;
  margin-right: 0%;
}

.col-5 .video-list {
  max-height: none;
  height: 390px;
  overflow-y: auto;
}

.row .col-5 {
  max-width: none;
}

.media-container {
  height: 36vh;
  overflow: hidden;
  min-width: 0;
  min-height: 0;
}

video {
  height: 350px;
}

.video-player {
  height: 400px;
}



.form-text .form-number-input {
  width: 80px;
  margin-left: 10px;
}

.row.mt-2.mb-2 {
  padding-bottom: 10px;
}
</style>
